import React from 'react';
import * as S from './SelectedBase.styled';
import Header from './components/header/Header';
import NothingSelected from './components/nothingSelected/NothingSelected';

const SelectedBase = ({
  children,
  excludeSet,
  includeSet,
  clearIncludeItems,
  clearExcludeItems,
}) => {
  return (
    <S.Container>
      <Header
        excludeLength={excludeSet.length}
        includeLength={includeSet.length}
        clearIncludeItems={clearIncludeItems}
        clearExcludeItems={clearExcludeItems}
      />
      <S.SelectedMain>
        {excludeSet.length || includeSet.length ? (
          <S.Selected>{children}</S.Selected>
        ) : (
          <NothingSelected />
        )}
      </S.SelectedMain>
    </S.Container>
  );
};

export default SelectedBase;
